export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export const PASSWORD_MIN_LENGTH = 8

export const validateName = (value: string): string | null => {
    const name = value.trim()

    if (!name) return "نام خود را وارد کنید."
    if (name.length < 2) return "نام باید دست‌کم ۲ حرف باشد."
    if (name.length > 60) return "نام نباید بیشتر از ۶۰ حرف باشد."

    return null
}

export const validateEmail = (value: string): string | null => {
    const email = value.trim()

    if (!email) return "ایمیل خود را وارد کنید."
    if (email.length > 254 || !EMAIL_PATTERN.test(email)) return "یک ایمیل معتبر وارد کنید."

    return null
}

export const validatePassword = (value: string): string | null => {
    if (!value) return "رمز عبور را وارد کنید."
    if (value.length < PASSWORD_MIN_LENGTH) return "رمز عبور باید دست‌کم ۸ کاراکتر باشد."
    if (value.length > 128) return "رمز عبور نباید بیشتر از ۱۲۸ کاراکتر باشد."

    return null
}

export const passwordStrength = (value: string): { score: number, label: string } => {
    if (!value) return { score: 0, label: '' }

    let score = 0
    if (value.length >= PASSWORD_MIN_LENGTH) score += 1
    if (value.length >= 12) score += 1
    if (/\d/.test(value) && /[^\d\s]/.test(value)) score += 1
    if (/[^a-zA-Z0-9؀-ۿ\s]/.test(value) || (/[a-z]/.test(value) && /[A-Z]/.test(value))) score += 1

    const labels = ["خیلی ضعیف", "ضعیف", "متوسط", "خوب", "قوی"]

    return { score, label: labels[score] }
}
